<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__main">
        <!-- 左侧：Logo + 品牌信息 -->
        <div class="footer__brand">
          <div class="footer__logo">
            <img src="@/assets/logo.png" alt="绿豚陪诊" />
            <span class="footer__logo-text">绿豚陪诊</span>
          </div>
          <p class="footer__slogan">专业陪伴 · 全程无忧</p>
          <p class="footer__desc">
            专注陪诊、陪护、绿通加号服务，让每一次就医都有人陪。
          </p>
        </div>

        <!-- 中间：联系方式 -->
        <div class="footer__contact">
          <h4 class="footer__title">联系我们</h4>
          <div class="footer__contact-item">
            <span class="footer__contact-label">电话</span>
            <a href="tel:400-021-9660" class="footer__contact-value">400-021-9660</a>
          </div>
          <div class="footer__contact-item">
            <span class="footer__contact-label">邮箱</span>
            <a href="mailto:zhaoxingrong@dyd6688.com" class="footer__contact-value">zhaoxingrong@dyd6688.com</a>
          </div>
          <div class="footer__contact-item">
            <span class="footer__contact-label">地址</span>
            <span class="footer__contact-value">上海市闵行区虹莘路1955弄</span>
          </div>
        </div>

        <!-- 右侧：二维码 -->
        <div class="footer__qr">
          <div class="footer__qr-item">
            <img
                src="https://ltfxpz.oss-cn-shanghai.aliyuncs.com/gh_6e23b31ec8d4_430.jpg"
                alt="绿豚陪诊小程序"
            />
            <span>小程序</span>
          </div>
          <div class="footer__qr-item">
            <img
                src="https://ltfxpz.oss-cn-shanghai.aliyuncs.com/%E7%BB%BF%E8%B1%9A%E9%99%AA%E8%AF%8A%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.jpg"
                alt="绿豚陪诊公众号"
            />
            <span>微信公众号</span>
          </div>
        </div>
      </div>

      <!-- 底部版权 -->
      <div class="footer__bottom">
        <p class="footer__copyright">
          © {{ currentYear }} 绿豚嘀嘀陪同（上海）医疗科技有限公司 版权所有
        </p>
        <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener"
            class="footer__icp"
        >
          沪ICP备2025108886号
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer {
  background: #1a2b3c;
  color: #cbd5e1;
  padding: 60px 0 28px;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

/* ===================== 主内容区 ===================== */
.footer__main {
  display: grid;
  grid-template-columns: 1.3fr 1.4fr 1fr;
  gap: 60px;
  padding-bottom: 48px;
  border-bottom: 1px solid #2d3f52;
}

/* ===================== 左侧品牌 ===================== */
.footer__brand {
  display: flex;
  flex-direction: column;
}
.footer__logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}
.footer__logo img {
  height: 48px;
  width: auto;
  object-fit: contain;
}
.footer__logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
}
.footer__slogan {
  font-size: 16px;
  color: var(--gt-primary);
  font-weight: 600;
  letter-spacing: 2px;
  margin-bottom: 12px;
}
.footer__desc {
  font-size: 14px;
  color: #94a3b8;
  line-height: 1.9;
  max-width: 340px;
}

/* ===================== 中间联系方式 ===================== */
.footer__contact {
  display: flex;
  flex-direction: column;
}
.footer__title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 24px;
  position: relative;
  padding-left: 12px;
}
.footer__title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: var(--gt-primary);
  border-radius: 2px;
}
.footer__contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.6;
}
.footer__contact-label {
  color: #64748b;
  flex-shrink: 0;
  width: 48px;
  padding-top: 1px;
}
.footer__contact-value {
  color: #cbd5e1;
  transition: color 0.2s;
  word-break: break-all;
}
a.footer__contact-value:hover {
  color: var(--gt-primary);
}

/* ===================== 右侧二维码 ===================== */
.footer__qr {
  display: flex;
  gap: 24px;
  justify-content: flex-end;
}
.footer__qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer__qr-item img {
  width: 110px;
  height: 110px;
  object-fit: cover;
  border-radius: 8px;
  background: #fff;
  padding: 4px;
  margin-bottom: 10px;
}
.footer__qr-item span {
  font-size: 13px;
  color: #94a3b8;
}

/* ===================== 底部版权 ===================== */
.footer__bottom {
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: #64748b;
}
.footer__copyright {
  margin: 0;
}
.footer__icp {
  color: #64748b;
  transition: color 0.2s;
}
.footer__icp:hover {
  color: var(--gt-primary);
}

/* ===================== 响应式 ===================== */
@media (max-width: 1100px) {
  .footer__main {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
  .footer__qr {
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 48px 0 24px;
  }
  .container {
    padding: 0 24px;
  }
  .footer__main {
    grid-template-columns: 1fr;
    gap: 40px;
    padding-bottom: 32px;
  }
  .footer__logo img {
    height: 40px;
  }
  .footer__logo-text {
    font-size: 20px;
  }
  .footer__qr {
    justify-content: flex-start;
  }
  .footer__bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
